import { SubscribeToMoreOptions } from '@apollo/client/core/watchQueryOptions';
import { useEffect } from 'react';

import { PostType, PublishStatus } from '../../../graphql/gen/types';
import { GET_POSTS_SUBSCRIPTION } from '../../../graphql/subscriptions/GetPosts';
import { updateWithSubscriptionItem } from './updateWithSubscriptionItem';

export function useSubscribeToMorePosts(
  subscribeToMore: (options: SubscribeToMoreOptions) => void,
  variables: {
    labelIds: string[];
    plexIds: string[];
    publishStatuses: PublishStatus[];
    types?: PostType[];
    before?: string;
    onOrAfter?: string;
  }
): void {
  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: GET_POSTS_SUBSCRIPTION,
      variables: variables,
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || !subscriptionData.data) return prev;
        const newItem = subscriptionData.data.posts;
        const existingItems = prev.posts?.items || [];

        return {
          ...prev,
          posts: {
            ...prev.posts,
            items: updateWithSubscriptionItem({ newItem, existingItems, newItemLocation: 'front' }),
            nextCursor: null,
          },
        };
      },
    });

    return unsubscribe;
  }, [subscribeToMore, variables]);
}
